function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 3.875C5.79086 3.875 4 5.66586 4 7.875V18C4 20.2091 5.79086 22 8 22H15C17.2091 22 19 20.2091 19 18V7.875C19 5.66586 17.2091 3.875 15 3.875H8ZM8.6875 8.25C8.16973 8.25 7.75 8.66973 7.75 9.1875C7.75 9.70527 8.16973 10.125 8.6875 10.125H11.1875C11.7053 10.125 12.125 9.70527 12.125 9.1875C12.125 8.66973 11.7053 8.25 11.1875 8.25H8.6875ZM7.75 12.9375C7.75 12.4197 8.16973 12 8.6875 12H14.3125C14.8303 12 15.25 12.4197 15.25 12.9375C15.25 13.4553 14.8303 13.875 14.3125 13.875H8.6875C8.16973 13.875 7.75 13.4553 7.75 12.9375ZM8.6875 15.75C8.16973 15.75 7.75 16.1697 7.75 16.6875C7.75 17.2053 8.16973 17.625 8.6875 17.625H14.3125C14.8303 17.625 15.25 17.2053 15.25 16.6875C15.25 16.1697 14.8303 15.75 14.3125 15.75H8.6875Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.5,
  y: 2,
  width: 9.375,
  height: 3.75,
  rx: 1.875,
  fill: "#E0E0E0"
});
function SvgIconOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/iconOrder.d13d7797.svg";
export { ForwardRef as ReactComponent };